import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IIdentification } from "../types/IdentificationTypes";

interface IIdentificationState {
  identification: IIdentification | null;
  isLoading: boolean;
  error: string;
}

const initialState: IIdentificationState = {
  identification: null,
  isLoading: false,
  error: "",
};

export const identificationSlice = createSlice({
  name: "identification",
  initialState,
  reducers: {
    identificationSuccess(state, action: PayloadAction<IIdentification>) {
      state.identification = action.payload;
      state.error = "";
      state.isLoading = false;
    },

    identificationLoading(state) {
      state.identification = null;
      state.error = "";
      state.isLoading = true;
    },

    identificationFailed(state, action: PayloadAction<string>) {
      state.identification = null;
      state.error = action.payload;
      state.isLoading = false;
    },

    identificationReset(state) {
      state.identification = null;
      state.isLoading = false;
      state.error = "";
    },
  },
});

export default identificationSlice.reducer;